export function abbreviateName(fullName) {
  if (!fullName) return ""; // Gestisce il caso in cui fullName è null o undefined

  return fullName
    .split(" ")
    .map((name) => name.charAt(0).toUpperCase() + ".")
    .join("");
}
